import React from "react";
import { exportToExcel } from "views/pages/manage/unAssigned/collectPayment/selectCharges/downloadChargesData/downloadExcel/exportToExcel";
import AButton from "../../../../common/form-fields-mui/AButton";
// src/helpers/formatColumnDate.js
import moment from "moment";


export const formatMaterialDatesWithTimestamp = (
  data,
  dateFields = ["createdOn", "updatedOn"],
  format = "DD-MM-YYYY HH:mm:ss"
) => {
  return data.map((item) => {
    const formattedItem = { ...item };
    dateFields.forEach((field) => {
      if (formattedItem[field]) {
        formattedItem[field] = `${moment(formattedItem[field]).format(format)} by ${formattedItem['updatedBy']}`;
      }
    });
    return formattedItem;
  });
};


const headers = [
  { label: "Material number", key: "materialId" },
  { label: "Material description", key: "materialDescription" },
  { label: "Type", key: "serialNumberProfile" },
  { label: "UOM", key: "baseUnitOfMeasure" },
  { label: "SAP plant ID", key: "plantId" },
  { label: "Pkg.Code", key: "categoryDispValue" },
  { label: "Language", key: "languageDispValue" },
  { label: "Class", key: "classDispValue" },
  { label: "Career", key: "academicCareerDispValue" },
  { label: "Course Attribute", key: "courseAttribute" },
  { label: "SAP status", key: "materialStatus" },
  { label: "Last updated", key: "updatedOn" },
];

const getReadableFileName = (baseName = "export") => {
  const now = new Date();
  const dateStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(now.getDate()).padStart(2, "0")}`;
  const timeStr = `${String(now.getHours()).padStart(2, "0")}${String(
    now.getMinutes()
  ).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;
  return `${baseName}_${dateStr}_${timeStr}`;
};

const DownloadMaterialData = ({ materials }) => {
  const downloadHandler = async () => {
    try {
      const formattedMaterials = formatMaterialDatesWithTimestamp(materials)
      exportToExcel(formattedMaterials, headers, getReadableFileName("materialMaster"));
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <AButton
      variant="primary_filled"
      className=" ml-2"
      size="xs"
      onClick={() => {
        downloadHandler();
      }}
    >
      Download csv
    </AButton>
  );
};

export default DownloadMaterialData;
